/* global axios */
import ApiClient from "./ApiClient";

class ConversationApi extends ApiClient {
  constructor() {
    super("conversations", { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }

  getUnipileHistoryStatus(conversationID) {
    return axios.get(
      `${this.url}/${conversationID}/unipile_history_status`
    );
  }

  importUnipileHistory(conversationID) {
    return axios.post(
      `${this.url}/${conversationID}/import_unipile_history`
    );
  }
}

export default new ConversationApi();
